module.exports = __webpack_public_path__ + "static/media/2.96fb3b75.jpg";